module.exports = __webpack_public_path__ + "img/4.46cde4e.jpg";